import {
  GAME_CREATE,
  GAME_ADD_PLAYER,
  GAME_ADD_ROUND,
  GAME_SET_CURRENT
  // GAME_REMOVE_PLAYER
} from '../actionTypes';
export const initialState = {
  byId: {},
  allIds: [],
  currentGame: ''
};

export default function(state = initialState, action) {
  if (action.payload)
    var {
      id, //todo consolidate into gameid
      dateStarted,
      rounds,
      players,
      gameId,
      roundId,
      playerId
    } = action.payload;

  switch (action.type) {
    case GAME_CREATE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: {
            id,
            dateStarted,
            rounds, //should be empty rn
            players //should be empty rn
          }
        },
        currentGame: id,
        allIds: [...state.allIds, id]
      };
    case GAME_SET_CURRENT:
      return {
        ...state,
        currentGame: id
      };
    case GAME_ADD_ROUND:
      return {
        ...state,
        byId: {
          ...state.byId,
          [gameId]: {
            ...state.byId[gameId],
            rounds: [...state.byId[gameId].rounds, roundId]
          }
        }
      };
    case GAME_ADD_PLAYER:
      return {
        ...state,
        byId: {
          ...state.byId,
          [gameId]: {
            ...state.byId[gameId],
            players: [...state.byId[gameId].players, playerId]
          }
        }
      };
    default:
      return state;
  }
}
